import React, { SVGProps } from 'react';

const CommunityIcon = (props: SVGProps<SVGSVGElement>) => (
  <span className="anticon anticon-appstore ant-menu-item-icon">
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5.5c0-.736.598-1.334 1.333-1.334a1.335 1.335 0 0 1 0 2.667A1.335 1.335 0 0 1 4 5.5zm-1.333 0a2.67 2.67 0 0 0 2.667 2.666A2.67 2.67 0 0 0 8 5.5a2.67 2.67 0 0 0-2.667-2.667A2.67 2.67 0 0 0 2.667 5.5zM8 14.166h1.334c0-3.856-2.176-4.666-4-4.666-1.825 0-4 .81-4 4.666h1.333c0-2.954 1.425-3.333 2.667-3.333 1.24 0 2.666.379 2.666 3.333zm3.334-3.916c-.68 0-1.284.161-1.808.428.187.317.351.675.48 1.089.387-.213.829-.35 1.328-.35 2.088 0 2.183 2.104 2.183 2.75h1.15c0-2.38-1.258-3.917-3.333-3.917zM10.25 7.166a1.085 1.085 0 1 1 1.083 1.083 1.085 1.085 0 0 1-1.083-1.083zm-1.166 0c0 1.241 1.009 2.25 2.25 2.25 1.24 0 2.25-1.009 2.25-2.25 0-1.24-1.01-2.25-2.25-2.25-1.241 0-2.25 1.01-2.25 2.25z"
        fill="#5A656D"
      />
    </svg>
  </span>
);

export default CommunityIcon;
